@if (switchService.showInTenantShell()) {
  <button
    type="button"
    class="context-pill context-pill--button context-pill--location context-pill--tenant"
    [matMenuTriggerFor]="locationMenu"
    [attr.aria-label]="'header.locationSwitcher.menuLabel' | translate"
    [attr.title]="displayName()"
  >
    <span
      class="context-pill__avatar"
      [style.background]="activeLogoUrl() ? '#ffffff' : activeBrandColor()"
    >
      @if (activeLogoUrl()) {
        <img [src]="activeLogoUrl()" alt="" (error)="onLogoError()" />
      } @else {
        <span>{{ activeInitials() }}</span>
      }
    </span>
    <span class="context-pill__label truncate">{{ displayName() }}</span>
    <i-tabler name="chevron-down" class="context-pill__chevron shrink-0"></i-tabler>
  </button>

  <mat-menu #locationMenu="matMenu" class="cardWithShadow">
    <div class="px-4 py-2 text-xs font-semibold text-muted">
      {{ 'header.locationSwitcher.menuLabel' | translate }}
    </div>
    @for (location of switchService.accessibleLocations(); track location.id) {
      <button
        mat-menu-item
        type="button"
        (click)="selectLocation(location.id)"
        [disabled]="switchService.isActive(location.id)"
      >
        <span class="flex items-center gap-2 min-w-0">
          @if (switchService.isActive(location.id)) {
            <i-tabler name="check" class="text-primary shrink-0"></i-tabler>
          } @else {
            <span class="inline-block w-[18px] shrink-0"></span>
          }
          <span class="truncate">{{ location.name }}</span>
        </span>
      </button>
    }
  </mat-menu>
} @else if (switchService.showInPosShell()) {
  @if (switchService.canSwitchInPosShell()) {
    <button
      type="button"
      class="context-pill context-pill--button context-pill--location context-pill--pos"
      [matMenuTriggerFor]="posLocationMenu"
      [attr.aria-label]="'header.locationSwitcher.menuLabel' | translate"
      [attr.title]="displayName()"
    >
      <span
        class="context-pill__avatar"
        [style.background]="activeLogoUrl() ? '#ffffff' : activeBrandColor()"
      >
        @if (activeLogoUrl()) {
          <img [src]="activeLogoUrl()" alt="" (error)="onLogoError()" />
        } @else {
          <span>{{ activeInitials() }}</span>
        }
      </span>
      <span class="context-pill__label truncate">{{ displayName() }}</span>
      <i-tabler name="chevron-down" class="context-pill__chevron shrink-0"></i-tabler>
    </button>

    <mat-menu #posLocationMenu="matMenu" class="cardWithShadow">
      <div class="px-4 py-2 text-xs font-semibold text-muted">
        {{ 'header.locationSwitcher.menuLabel' | translate }}
      </div>
      @for (location of switchService.accessibleLocations(); track location.id) {
        <button
          mat-menu-item
          type="button"
          (click)="selectLocation(location.id)"
          [disabled]="switchService.isActive(location.id)"
        >
          <span class="flex items-center gap-2 min-w-0">
            @if (switchService.isActive(location.id)) {
              <i-tabler name="check" class="text-primary shrink-0"></i-tabler>
            } @else {
              <span class="inline-block w-[18px] shrink-0"></span>
            }
            <span class="truncate">{{ location.name }}</span>
          </span>
        </button>
      }
    </mat-menu>
  } @else {
    <span
      class="context-pill context-pill--location context-pill--status context-pill--pos"
      [attr.title]="displayName()"
      [attr.aria-label]="displayName()"
      role="status"
    >
      <span
        class="context-pill__avatar"
        [style.background]="activeLogoUrl() ? '#ffffff' : activeBrandColor()"
      >
        @if (activeLogoUrl()) {
          <img [src]="activeLogoUrl()" alt="" (error)="onLogoError()" />
        } @else {
          <span>{{ activeInitials() }}</span>
        }
      </span>
      <span class="context-pill__label truncate">{{ displayName() }}</span>
    </span>
  }
}
